import { Card } from 'components/Card';
import { Txt } from 'components/Txt';
import { FontFamilySemibold, theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { LineGraphData } from 'types/Reports';
import {
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryTheme,
} from 'victory-native';

type Props = {
  title: string;
  data: LineGraphData;
  width?: number;
  height?: number;
};

export const LineGraph: React.FC<Props> = ({
  title,
  data,
  width = 250,
  height = 250,
}) => {
  // const [zoomDomain, setZoomDomain] = React.useState<
  //   | undefined
  //   | {
  //       x: [number, number];
  //       y: [number, number];
  //     }
  // >();
  // const [brushDomain, setBrushDomain] = React.useState<
  //   | undefined
  //   | {
  //       x: [number, number];
  //       y: [number, number];
  //     }
  // >();
  // const brushHeight = 50;
  return (
    <Card
      contentStyle={{
        backgroundColor: 'white',
      }}
      margin={false}
      marginHorizontal={false}
    >
      <View style={{ flexDirection: 'row', height }}>
        <View>
          <VictoryChart
            width={width}
            theme={VictoryTheme.material}
            padding={{ top: 15, left: 35, right: 25, bottom: 30 }}
            domainPadding={{ x: 10, y: 15 }}
            height={height}
            // height={height - brushHeight}
            // containerComponent={
            //   <VictoryZoomContainer
            //     responsive={false}
            //     zoomDimension="x"
            //     zoomDomain={zoomDomain}
            //     onZoomDomainChange={(a) => setBrushDomain(a)}
            //   />
            // }
          >
            <VictoryAxis
              theme={VictoryTheme.material}
              dependentAxis
              standalone={false}
              style={{
                tickLabels: {
                  fontSize: 12,
                  padding: 2,
                },
              }}
              tickFormat={(y) => Math.round(y)}
            />
            <VictoryAxis
              theme={VictoryTheme.material}
              tickCount={5}
              width={width}
              tickValues={data.x.map((x) => x.label)}
              style={{
                tickLabels: {
                  fontSize: 12,
                  padding: 2,
                },
              }}
              standalone={false}
            />
            {data.groups.map((group) => (
              <VictoryLine
                key={group.key}
                labels={({ datum: { y } }) => (!y ? ' ' : y)}
                style={{
                  data: {
                    stroke: `#${group.color}`,
                    strokeWidth: 3,
                  },
                  labels: {
                    fill: `#${group.color}`,
                    fontFamily: FontFamilySemibold,
                    padding: 2,
                  },
                  border: {
                    fontFamily: FontFamilySemibold,
                  },
                }}
                data={data.x.map((x) => ({
                  x: x.label,
                  y: data.groupedValues?.[group.key]?.[x.key] || 0,
                }))}
                animate={false}
              />
            ))}
          </VictoryChart>
        </View>
        {/* <SeparatorHorizontal />
          <View>
            <VictoryChart
              width={width}
              height={brushHeight}
              padding={{ top: 10, left: 38, right: 20, bottom: 30 }}
              containerComponent={
                <VictoryBrushContainer
                  responsive={false}
                  brushDimension="x"
                  brushDomain={brushDomain}
                  onBrushDomainChange={(a) => setZoomDomain(a)}
                />
              }
            >
              {[data.groups[0]!].map((group) => (
                <VictoryAxis
                  key={group.key}
                  tickCount={6}
                  width={width}
                  tickValues={data.x.map((x) => x.label)}
                  style={{
                    tickLabels: {
                      fontSize: 12,
                      padding: 2,
                    },
                  }}
                />
              ))}
              {data.groups.map((group) => (
                <VictoryLine
                  key={group.key}
                  style={{
                    data: {
                      stroke: `#${group.color}`,
                      strokeWidth: 1,
                    },
                  }}
                  data={data.x.map((x) => ({
                    x: x.label,
                    y: data.groupedValues?.[group.key]?.[x.key] || 0,
                  }))}
                />
              ))}
            </VictoryChart>
          </View> */}
      </View>
      <View
        style={{
          paddingVertical: theme.paddingHorizontalHalf,
          paddingHorizontal: theme.paddingHorizontal,
          backgroundColor: theme.colors.background50,
        }}
      >
        <Txt
          numberOfLines={1}
          weight="bold"
          size="xsmall"
          style={{ color: theme.colors.fieldValueText }}
        >
          {title}
        </Txt>
      </View>
    </Card>
  );
};
